module.exports = __webpack_public_path__ + "img/pc-character-placeholder.e00949fb.webp";